// @flow @jsx h
import { Component, h } from 'preact'
import { SerumImage } from '@nrk/dh-feature-components'

/* styles */
import styles from './index.css'
import { gridAspect } from '../../grid.css'

/* types */
import type { SimpleImageType } from '../../domain'

type Props = {
  images: SimpleImageType[],
}

export class DobbelBildeBlokk extends Component<Props> {
  render () {
    const { images } = this.props
    if (images.length < 2) {
      return <div>Denne komponenten krever minst 2 bilder.</div>
    }

    return <div class={styles.dobbelBildeBlokk + ' ' + gridAspect}>
      <div>
        <div class={styles.dobbelBildeBlokk__grid}>
          <figure>
            <div class={styles.dobbelBildeBlokk__image1}>
              <div>
                <SerumImage alt={images[0].alt} id={images[0].polopolyId} ratio={'169'} />
              </div>
            </div>
            <caption class={styles.dobbelBildeBlokk__caption1}>
              {images[0].caption}
            </caption>
          </figure>
          <figure>
            <div className={styles.dobbelBildeBlokk__image2}>
              <div className={gridAspect}>
                <SerumImage alt={images[1].alt} id={images[1].polopolyId} ratio={'169'} />
              </div>
            </div>
            <caption class={styles.dobbelBildeBlokk__caption2}>
              {images[1].caption}
            </caption>
          </figure>
        </div>
      </div>
    </div>
  }
}
